<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{ $t('string.msg.user.gasstation.label.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{ $t('string.msg.user.gasstation.label.decription') }}
                                </p>

                                <form>
                                    <div v-if="data._id" class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.product.brand.label.id') }}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control" />
                                        </div>

                                        <!-- <div class="form-group col-md-3 text-center">
                                            <br/><br/>
                                            <button v-on:click="confirmArchive" class="text-dark-gray btn btn-warning w-50">{{$t('string.msg.status.archive')}}</button>
                                        </div> -->
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.user.gasstation.label.name') }}
                                            </label>
                                            <input type="text" v-model="data.name" class="form-control" :placeholder="$t('string.msg.user.gasstation.placeholder.name')" />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.user.gasstation.label.latitude') }}
                                            </label>
                                            <input type="text" v-model="data.latlng.latitude" step="any" class="form-control" :placeholder="$t('string.msg.user.gasstation.placeholder.latitude')" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.user.gasstation.label.longitude') }}
                                            </label>
                                            <input type="text" v-model="data.latlng.longitude" step="any" class="form-control" :placeholder="$t('string.msg.user.gasstation.placeholder.longitude')" />
                                        </div>
                                    </div>
                                    <br />
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button @click="clearForm" class="btn btn-secondary w-20">{{ $t('string.msg.form.btn.clear') }}</button>
                                        <button @click="save" class="btn btn-danger w-20">{{ $t('string.msg.form.btn.save') }}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem" />
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <FlashMessage />
    </div>
</template>

<script>
import Controller from './CrtGasStation'

import Spinner from '../../../components/layout/Spinner'
import Toast from '../../../components/layout/Toast'
import List from './ListGasStation'
import Vue from 'vue'
Vue.prototype.$eventHub = new Vue()

export default {
    name: 'GasStation',
    components: {
        Spinner,
        Toast,
        List,
    },
    data() {
        return {
            errors: [],
            valuekey: 0,
            text: null,
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            data: {
                status: 'ACTIVE',
                name: null,
                latlng: {
                    latitude: null,
                    longitude: null,
                },
            },
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this)
    },
    mounted() {},
}
</script>

<style>
</style>
